// src/components/AuthProvider.js
import { useEffect, useState, createContext, useContext} from 'react';
import { supabase } from '../lib/supabaseClient';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [session, setSession] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
  
    useEffect(() => {
      supabase.auth.getSession().then(({ data: { session } }) => {
        setSession(session);
      });
  
      const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
        setSession(session);
        if (session && location.pathname === "/login" && !localStorage.getItem('isNewUser')) {
            navigate("/");
          }
      });
  
      return () => listener.subscription.unsubscribe();
    }, [navigate]);
  
    const signOut = async () => {
      await supabase.auth.signOut();
      setSession(null); // just in case
    };
  
    return (
      <AuthContext.Provider value={{ session, signOut }}>
        {children}
      </AuthContext.Provider>
    );
  }

  export function useAuth() {
    return useContext(AuthContext);
  }
  